import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import * as request from "../admin/lib/lib";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { StringToDateWithDash } from '../utils/RegisterApplicationBodyFormatter';
export function News() {
    const [loading, setLoading] = useState(false);
    const [newsData, setnewsData] = useState([]);
    const [expandedItemId, setExpandedItemId] = useState(null);

    useEffect(() => {
        const populateNews = async () => {
            try {
                setLoading(true);
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'GetInfo/News');

                const sorted = response.sort((a, b) => {
                    const dateA = StringToDateWithDash(a.data);
                    const dateB = StringToDateWithDash(b.data);
                    return dateB - dateA; // за низходящ ред (новите първо)
                });

                setnewsData(sorted);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        populateNews();
        document.title = `Новини`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.

    const handleExpand = (index) => {
        setExpandedItemId(index === expandedItemId ? null : index);
    };

    return (
        <div className="cust_page">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="title_news pt-1 pb-5">Новини</div>
            <Accordion activeIndex={0}>
                {!newsData ? (
                    <p>...</p>
                ) : (
                    newsData.map((nd, index) => (



                        <AccordionTab key={index} header=
                            {
                            <span className="flex flex-wrap align-items-center gap-2 w-100">
                                <label className="w-100 color-black pb-2">{nd.data || "No date provided"}</label>
                                <span className=" color-blue">{nd.title || "Untitled"}</span>
                                </span>
                            }>
                            <p className="m-0">
                                {nd.news ? <div className="suneditor-preview" dangerouslySetInnerHTML={{ __html: nd.news }}/> : "No content available."}
                            </p>
                        </AccordionTab>



                    ))
                )}
            </Accordion>
        </div>
    );
}

export default News;